export default "__VITE_ASSET__6e4143d1__"